var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDone = function SvgDone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-20": 13,
    "data-width-24": 14.1,
    viewBox: "0 0 14.1 9.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.879.22a.75.75 0 0 1 0 1.06l-8.302 8.3a.75.75 0 0 1-1.058.002L.222 5.326A.75.75 0 1 1 1.278 4.26l3.767 3.731L12.818.22a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDone);
export default ForwardRef;